import OnlineBookingPromoCodesList from "views/OnlineBookingPromoCodes/OnlineBookingPromoCodesList";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import CreateOnlineBookingsPromoCode from "views/OnlineBookingPromoCodes/CreateOnlineBookingPromoCodes";
import EditOnlineBookingPromoCodes from "views/OnlineBookingPromoCodes/EditOnlineBookingPromoCodes";
import ViewOnlineBookingsPromoCode from "views/OnlineBookingPromoCodes/ViewOnlineBookingPromoCodes";
import DeleteOnlineBookingsPromoCode from "views/OnlineBookingPromoCodes/DeleteOnlineBookingPromoCodes";
import { token } from "functions/Helper";

const onlineBookingPromoCode = () => {
  let views = [];

  if (
    token["booking.online_booking_promo_codes.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/OnlineBookingPromoCodesList",
      name: "Online Booking Promo Code",
      icon: MonetizationOnIcon,
      component: OnlineBookingPromoCodesList,
      layout: "/admin"
    });
  }
  return views;
};

const onlineBookingPromoCodeHidden = () => {
  let views = [];

  if (
    token["booking.online_booking_promo_codes.write"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views = views.concat([
      {
        path: "/OnlineBookingPromoCodes/Create",
        name: "Create Online Booking Promo Codes",
        component: CreateOnlineBookingsPromoCode,
        layout: "/admin"
      },
      {
        path: "/OnlineBookingPromoCodes/Edit",
        name: "Edit Online Booking Promo Codes",
        component: EditOnlineBookingPromoCodes,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/OnlineBookingPromoCodes/Delete",
        name: "Delete Online Booking Promo Codes",
        component: DeleteOnlineBookingsPromoCode,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      }
    ]);
  }

  if (
    token["booking.online_booking_promo_codes.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/OnlineBookingPromoCodes/View",
      name: "View Online Booking Promo Codes",
      component: ViewOnlineBookingsPromoCode,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }
  return [
    {
      collapse: true,
      name: "Online Booking Hidden",
      state: "onlineBookingHidden",
      hideInSidebar: true,
      views: views
    }
  ];
};

export { onlineBookingPromoCode, onlineBookingPromoCodeHidden };
